import { Box } from "@mui/material"
import styles from "./task-list-header.module.css"

export const TaskListHeaderDefault: React.FC<{
  headerHeight: number
  rowWidth: string
  fontFamily: string
  fontSize: string
}> = ({ headerHeight, fontFamily, fontSize, rowWidth }) => {
  return (
    <Box
      className={styles.ganttTable}
      sx={{
        fontFamily: fontFamily,
        fontSize: fontSize,
        width: "100%",
      }}
    >
      <Box
        className={styles.ganttTable_Header}
        sx={{
          height: headerHeight - 2,
        }}
      >
        <Box
          className={styles.ganttTable_HeaderItem}
          sx={{
            minWidth: rowWidth,
          }}
        >
          &nbsp;Pipeline Name
        </Box>
      </Box>
    </Box>
  )
}
